import { useCallback, useMemo } from "react";

import { SIGNAL_SAMPLE_REQUEST_LIMIT } from "./constants";

import { StructuredSearchProvider } from "@/components/StructuredSearch";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import RequestLogsAgGrid from "@/routes/analytics/RequestLogsAgGrid";
import type { SignalSampleConfig } from "@/routes/analytics/RequestLogsAgGrid/SelectionActionBar";

interface AddRequestsFromHistoryDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  currentSampleCount: number;
  onAddRequestLogs: (requestLogIds: number[]) => boolean;
}

const AddRequestsFromHistoryDialog = ({
  open,
  onOpenChange,
  currentSampleCount,
  onAddRequestLogs,
}: AddRequestsFromHistoryDialogProps) => {
  const handleSuccess = useCallback(() => onOpenChange(false), [onOpenChange]);

  const signalSampleConfig = useMemo<SignalSampleConfig>(
    () => ({
      maxSampleSize: SIGNAL_SAMPLE_REQUEST_LIMIT,
      currentSampleCount,
      submitSample: requestLogIds => onAddRequestLogs(requestLogIds),
      handleSuccess,
    }),
    [currentSampleCount, handleSuccess, onAddRequestLogs],
  );

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent className="flex h-[85vh] max-w-[96vw] flex-col overflow-hidden sm:max-w-[1400px]">
        <DialogHeader>
          <DialogTitle>Add from Request History</DialogTitle>
        </DialogHeader>
        <div className="min-h-0 flex-1">
          <StructuredSearchProvider initialUrlHydrationReady>
            <RequestLogsAgGrid
              syncUrl={false}
              searchTitle="Requests"
              signalSampleConfig={signalSampleConfig}
              useExternalStructuredSearchProvider
            />
          </StructuredSearchProvider>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AddRequestsFromHistoryDialog;
